import React from "react";

const TermsAndConditions = () => {
  return (
    <div className="">
      {/* <h1 className="text-3xl font-bold mb-4">Terms and Conditions</h1> */}
      <p className="text-gray-600">Effective Date: 1 January 2025</p>

      <p>
        Welcome to FindNigeriaProperties.com (&quot;the Platform&quot;), a real
        estate marketplace and investment platform. By accessing or using the
        Platform, you agree to be bound by these Terms and Conditions
        (&quot;Terms&quot;). If you do not agree with these Terms, please
        refrain from using the Platform.
      </p>

      <h2 className="text-2xl font-semibold mt-6">1. Definitions</h2>
      <ul className="list-disc pl-6">
        <li>
          <strong>Platform:</strong> The website, mobile application, and all
          related services.
        </li>
        <li>
          <strong>User:</strong> Anyone accessing the Platform, including
          buyers, sellers, and investors.
        </li>
        <li>
          <strong>Content:</strong> Text, images, videos, data, and other
          materials available on the Platform.
        </li>
        <li>
          <strong>Investment Products:</strong> Various real estate investment
          opportunities.
        </li>
        <li>
          <strong>Service Provider:</strong> Property developers, fund managers,
          or agents.
        </li>
      </ul>

      <h2 className="text-2xl font-semibold mt-6">2. Eligibility</h2>
      <ul className="list-disc pl-6">
        <li>
          Users must be at least 18 years old and legally capable of entering
          into contracts.
        </li>
        <li>
          By using the Platform, you confirm that all registration details
          provided are accurate.
        </li>
      </ul>

      <h2 className="text-2xl font-semibold mt-6">
        3. Account Registration and Security
      </h2>
      <ul className="list-disc pl-6">
        <li>
          Users must create an account to access certain Platform features.
        </li>
        <li>
          You are responsible for keeping your account credentials secure.
        </li>
        <li>Report any unauthorized use of your account immediately.</li>
        <li>
          The Platform may suspend accounts for violations of these Terms.
        </li>
      </ul>

      <h2 className="text-2xl font-semibold mt-6">4. Services Provided</h2>

      <h3 className="text-xl font-medium mt-4">4.1. Real Estate Listings:</h3>
      <ul className="list-disc pl-6">
        <li>
          The Platform enables sellers and realtors to list properties for sale
          or lease.
        </li>
        <li>The Platform is not a direct party to transactions.</li>
      </ul>

      <h3 className="text-xl font-medium mt-4">
        4.2. Investment Opportunities:
      </h3>
      <ul className="list-disc pl-6">
        <li>
          Users can access investment products such as land banking and
          sponsorship investments.
        </li>
        <li>Investments are managed by licensed fund managers.</li>
        <li>
          The Platform does not guarantee returns or assume investment risks.
        </li>
      </ul>

      <h2 className="text-2xl font-semibold mt-6">5. Fees and Payments</h2>
      <ul className="list-disc pl-6">
        <li>
          <strong>Listing Fees:</strong> Sellers or Service Providers may be
          charged for property listings.
        </li>
        <li>
          <strong>Transaction Fees:</strong> Fees may apply to investments and
          property transactions.
        </li>
        <li>
          All fees are disclosed upfront and are non-refundable unless stated
          otherwise.
        </li>
        <li>Payments must be made through approved payment methods.</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-6">6. User Responsibilities</h2>

      <h3 className="text-xl font-medium mt-4">6.1. Compliance with Laws:</h3>
      <p>Users must comply with all relevant property and investment laws.</p>

      <h3 className="text-xl font-medium mt-4">6.2. Prohibited Activities:</h3>
      <ul className="list-disc pl-6">
        <li>Misrepresenting properties or investments.</li>
        <li>Uploading false, defamatory, or illegal content.</li>
        <li>Attempting to interfere with the Platform’s operations.</li>
        <li>Using bots or unauthorized tools to access the Platform.</li>
      </ul>

      <h3 className="text-xl font-medium mt-4">6.3. Due Diligence:</h3>
      <p>
        Buyers and investors are responsible for conducting independent due
        diligence.
      </p>

      <h2 className="text-2xl font-semibold mt-6">
        7. Content Ownership and Use
      </h2>

      <h3 className="text-xl font-medium mt-4">7.1. User-Generated Content:</h3>
      <p>
        Users retain ownership but grant the Platform a license to use uploaded
        content.
      </p>

      <h3 className="text-xl font-medium mt-4">7.2. Platform Content:</h3>
      <p>
        All intellectual property on the Platform is owned by
        FindNigeriaProperties.com.
      </p>

      <h2 className="text-2xl font-semibold mt-6">
        8. Disclaimers and Limitation of Liability
      </h2>

      <h3 className="text-xl font-medium mt-4">8.1. No Guarantees:</h3>
      <p>
        The Platform does not guarantee the accuracy of listings or investment
        opportunities.
      </p>

      <h3 className="text-xl font-medium mt-4">8.2. Investment Risk:</h3>
      <p>
        Investments may result in financial loss. Users should seek financial
        advice.
      </p>

      <h3 className="text-xl font-medium mt-4">
        8.3. Limitation of Liability:
      </h3>
      <p>
        The Platform’s liability is limited to the fees paid by the User in the
        preceding 12 months.
      </p>

      <h2 className="text-2xl font-semibold mt-6">
        9. Third-Party Links and Services
      </h2>
      <p>
        The Platform is not responsible for third-party content or services.
      </p>

      <h2 className="text-2xl font-semibold mt-6">10. Termination</h2>
      <ul className="list-disc pl-6">
        <li>
          The Platform may suspend or terminate Users who violate these Terms.
        </li>
        <li>Users can terminate their account by providing written notice.</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-6">11. Privacy Policy</h2>
      <p>
        Refer to our{" "}
        <a href="#" className="text-blue-500">
          Privacy Policy
        </a>{" "}
        for details on data handling.
      </p>

      <h2 className="text-2xl font-semibold mt-6">
        12. Governing Law and Dispute Resolution
      </h2>

      <h3 className="text-xl font-medium mt-4">12.1. Governing Law:</h3>
      <p>
        These Terms are governed by the laws of the Federal Republic of Nigeria.
      </p>

      <h3 className="text-xl font-medium mt-4">12.2. Dispute Resolution:</h3>
      <ul className="list-disc pl-6">
        <li>Disputes will first be resolved through negotiation.</li>
        <li>
          If unresolved, disputes will be settled via arbitration under Nigerian
          law.
        </li>
      </ul>

      <h2 className="text-2xl font-semibold mt-6">13. Changes to Terms</h2>
      <p>
        The Platform may update these Terms, with Users notified of significant
        changes.
      </p>

      <h2 className="text-2xl font-semibold mt-6">14. Contact Information</h2>
      <p>
        Email:{" "}
        <a
          href="mailto:compliance@FindNigeriaProperties.com"
          className="text-blue-500"
        >
          compliance@FindNigeriaProperties.com
        </a>
        <br />
        Phone: +234 (806) 070 6906
        <br />
        Address: 7th Floor, CBC Towers, Lekki Phase 1, Lekki
      </p>

      <p className="mt-6">
        By using FindNigeriaProperties.com, you agree to these Terms and
        Conditions. Please read them carefully before proceeding.
      </p>
    </div>
  );
};

export default TermsAndConditions;
